<script>
import FormBasedProviderWidget from "./FormBasedProviderWidget";

export default {
  name: "FirstDataWidget",
  extends: FormBasedProviderWidget,
}
</script>